import type { DirectoryLink } from "@/api/db/people";

const linkLabel: Record<DirectoryLink, string> = {
	only_conversation: "Só conversa",
	patient_potential: "Potencial paciente",
	patient_confirmed: "Paciente confirmado",
};

const linkShort: Record<DirectoryLink, string> = {
	only_conversation: "Só conversa",
	patient_potential: "Potenciais",
	patient_confirmed: "Pacientes",
};

export const PessoasLabels = {
	link: linkLabel,
	linkShort,
	unnamed: "Sem nome",
	noStage: "Sem etapa",
	all: "Todas",
	results: "resultados",
	source: "Fonte",
	stage: "Etapa do funil",
	problem: "Problema no cadastro",
	problemFilter: "Com problema",
	unnamedContact: "contato sem nome",
};
